export const OPEN_API_URL = 'https://open-api.hashup.it';
